import { Dialog, DialogContent, DialogTitle } from '@efexteam/components';
import { useRole } from '@efexteam/permission-manager';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';
import { fetchWallets } from '@/modules/wallets/store';
import { fetchCombinedBalance } from '@/modules/combined_balance/store';
import { IWallet } from '../../../../services/client/types';
import SelectCurrencies, {
  ConfirmedDataProps,
  ConversionDataProps,
} from './steps/SelectCurrencies';
import ConfirmedData from './steps/confirmedData';

enum FormStep {
  FORM = 0,
  SUCCESS = 1,
}

interface IConvertModalProps {
  open: boolean;
  onClose: () => void;
  shouldReload: () => void;
  wallets: IWallet[] | undefined;
}

const ConvertModal = ({
  open,
  wallets,
  onClose,
  shouldReload,
}: IConvertModalProps) => {
  const { t } = useTranslation();
  const userProfile = useSelector(selectProfileData);
  const enterpriseId = userProfile?.company?.enterpriseId;
  const dispatch = useAppDispatch();

  const { isPaymentAnalyst } = useRole();

  const [formStep, setFormStep] = useState(FormStep.FORM);
  const [confirmData, setConfirmData] = useState<ConfirmedDataProps>(
    {} as ConfirmedDataProps
  );
  const [conversionData, setConversionData] = useState<ConversionDataProps>(
    {} as ConversionDataProps
  );

  const requestBalances = () => {
    if (enterpriseId) {
      dispatch(fetchWallets(enterpriseId));
      dispatch(fetchCombinedBalance(enterpriseId));
      shouldReload?.();
      onClose();
    }
  };

  useEffect(() => {
    if (!wallets && enterpriseId) {
      dispatch(fetchWallets(enterpriseId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wallets, enterpriseId]);

  if (!wallets) return null;

  return (
    <Dialog
      open={open}
      onClose={requestBalances}
      maxWidth="sm"
      fullWidth
      title={
        formStep === FormStep.FORM
          ? t(
              isPaymentAnalyst
                ? 'walletConfigureConvert'
                : 'walletConvertHeader'
            ) || ''
          : ''
      }
    >
      <DialogTitle showCloseButton onClick={requestBalances}>
        {formStep === FormStep.FORM
          ? t(
              isPaymentAnalyst
                ? 'walletConfigureConvert'
                : 'walletConvertHeader'
            ) || ''
          : ''}
      </DialogTitle>
      <DialogContent>
        {formStep === FormStep.FORM && (
          <SelectCurrencies
            goNextStep={() => setFormStep(FormStep.SUCCESS)}
            setConfirmedData={setConfirmData}
            setConversionData={setConversionData}
            wallets={wallets}
          />
        )}
        {formStep >= FormStep.SUCCESS && (
          <ConfirmedData
            conversionData={conversionData}
            data={confirmData}
            shouldReload={requestBalances}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ConvertModal;
